<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
      </div>
    </div>

    <div class="container-fluid ib-acquisition-bg">
      <div class="container ib-p-0">
        <div class="container multistep-box">
          <!-- flower for box -->
              <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" />
              <!-- flower for box -->
          <div class="row my-2">
            <div class="w-100" style="z-index:1 !important;">
              <span class="float-right">
                <router-link class="profile-edit-btn" :to="{ name: 'EditProfile' }">
                  Edit Profile
                </router-link>
              </span>
            </div>
            <div class="col-md-6 offset-md-3 order-2 order-md-1 jbl-user-medium ib-user-intro">
              <div class="">
                <div class="jbl-user-info">
                  <div class="position-relative">
                    <div class="jbl-profile-pic">
                      <img class="img-fluid" :src="user.avatar" alt="logo" />
                    </div>
                    <div class="founder-tag" v-if="user.is_founder_member">
                      <img class="img-fluid" alt="icon" :src="require('@/assets/images/founder.svg')" />
                    </div>
                  </div>
                  <div>
<!--                    <h4 v-if="user.middle_name != null && user.middle_name != undefined">{{ user.first_name + ' ' + user.middle_name + ' ' + user.last_name }}</h4>-->
                    <h4>{{ user.first_name + ' ' + user.last_name }}</h4>
                    <h5>{{ user.email }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row jbl-user-contact contact-icons wow animate__animated animate__fadeInUp">
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div>
                  <h5>Mobile</h5>
                  <h4>{{user.mobile_no}}</h4>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-3 ">
              <div class="d-flex align-items-center">
                <div>
                  <h5>CNIC</h5>
                  <h4>{{user.customer_details.cnic}}</h4>
                </div>
              </div>
            </div> -->
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div>
                  <h5>Username</h5>
                  <h4>{{user.username}}</h4>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <div>
                  <h5>Country</h5>
                  <h4>Pakistan</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import MaskedInput from "vue-masked-input";

  export default {
    name: "ViewProfile",
    data () {
      return {
        showLoader: false,
        user: {}
      };
    },
    components: {
      loading,
    },
    created () {
      const self = this;
      self.user = self.$store.getters.getUser;
    }
  };
</script>
<style scoped>
@media (max-width: 550px){
  .multistep-box {
    overflow-x: visible !important;
    overflow-y: visible !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Profile/View.vue